// src/pages/BhaktiHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const BhaktiHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Daily Bhakti Cycle");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Daily Bhakti Cycle", emoji: "🪔" },
    { label: "Learnings", emoji: "📚" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Digital Income", emoji: "💸" },
    { label: "Contest & Rewards", emoji: "🏆" },
    { label: "Market & Service", emoji: "🛍️" },
    { label: "Kritrim Medha", emoji: "🤖" },
  ];

  // FULL Bhakti Menu Buttons
  const menuButtons1 = [
    // 📚 Learning & Development
    { label: "Bhakti Learnings", emoji: "📘", link: "/bhakti-bookworld", group: "Learnings" },
    { label: "Bhakti Bookshelf", emoji: "📖", link: "/bookshelf", group: "Learnings" },
    { label: "Bhakti Satsang Sessions", emoji: "🕉️", link: "/enroll/workshop", group: "Learnings" },
    { label: "Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Learnings" },
    { label: "bhaktiTube", emoji: "▶️", link: "/bhaktitube", group: "Learnings" },
    { label: "Ashram Twin", emoji: "🌐", link: "/twiworld", group: "Learnings" },
    { label: "Bhakti MetaVerse", emoji: "🪄", link: "/msme-metaverse", group: "Learnings" },

    // 💸 DIGITAL INCOME
    { label: "Monthly Digital Income", emoji: "💸", link: "/bhakti-bookworld", group: "Digital Income" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Income" },


    // 💰 Bhakti Contest and Rewards
    { label: "Bhakti Ranking", emoji: "🏅", link: "/bhaktiscore", group: "Contest & Rewards" },
    { label: "Kharcho Jeeto", emoji: "🎁", link: "/kharchojeeto", group: "Contest & Rewards" },
    { label: "Photo Can Win", emoji: "📸", link: "/photocanwin", group: "Contest & Rewards" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Contest & Rewards" },
    { label: "Rewarding Ads", emoji: "📢", link: "/visigift-home", group: "Contest & Rewards" },
    { label: "Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Contest & Rewards" },

    // Daily Bhakti Cycle
    { label: "Guruji's Pravachan", emoji: "🪔", link: "/bhaktitube", group: "Daily Bhakti Cycle" },    
    { label: "Guruji's Tasks", emoji: "🙏", link: "/tasks-list", group: "Daily Bhakti Cycle" },
    { label: "DeepThinking", emoji: "🧘", link: "/fivewhys-analysis-home", group: "Daily Bhakti Cycle" },
    { label: "Actions & Reflections", emoji: "✍️", link: "/bhakti-self-chronicles", group: "Daily Bhakti Cycle" },    
    { label: "Guruji's Daily Learnings", emoji: "📜", link: "/tasks/add", group: "Daily Bhakti Cycle" },
    { label: "Bhakti Diary", emoji: "📓", link: "/mydiary-home", group: "Daily Bhakti Cycle" },
    { label: "Daily Learnings", emoji: "📝", link: "/tasks/add", group: "Daily Bhakti Cycle" },
    { label: "Bhakti Goal Board", emoji: "🎯", link: "/bhakti-goalboard", group: "Daily Bhakti Cycle" },
    { label: "Daily Chant", emoji: "📿", link: "/sanatan-chant", group: "Daily Bhakti Cycle" },

    // 🔄 Self Reflection
    { label: "Digital Card", emoji: "💳", link: "/digitalbhakticard", group: "Self Reflection" },
    { label: "Bhakti Soch", emoji: "🌸", link: "/povify-home", group: "Self Reflection" },
    { label: "Counselling", emoji: "🧑‍🏫", link: "/aicounselling", group: "Self Reflection" },

    // 🛍️ Bhakti Market & Service
    { label: "Souveniers", emoji: "🎁", link: "/orderflow-home", group: "Market & Service" },
    { label: "Pooja Items", emoji: "🪔", link: "/orderflow-home", group: "Market & Service" },
    { label: "Souveniers", emoji: "🎁", link: "/orderflow-home", group: "Market & Service" },

    // 🤖 Bhakti AI
    { label: "Bhakti AI", emoji: "👳", link: "/agenticsim", group: "Kritrim Medha" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-gray-900 border-b border-orange-600 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-yellow-300">🌼 Bhakti</div>
          <div className="text-[11px] lg:text-lg text-white">Connect. Reflect. Transform.</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="mt-4 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-orange-600 border-b border-orange-600 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 font-medium">Welcome, {userName}</div>
              <div className="flex gap-3">
                 <button
                  onClick={handleLogout}
                  className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">Login</Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links (desktop + mobile inline area) */}
      <div className="bg-orange-600 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/bhakti-vision" className="hover:text-yellow-200">💭 About Bhakti</a>
          <a href="/bhakti-faq" className="hover:text-yellow-200">🤔 FAQ</a>
        </div>
      </div>

      {/* Tabs (categories) */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-orange-600">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-0  border-orange-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main content area with grid of buttons */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-gray-900 border-t border-orange-600 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-white">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-orange-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-orange-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-orange-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-orange-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BhaktiHome;
